export const MAJOR_CAREER_MAJOR_OPTIONS = [
  '软件工程',
  '计算机科学与技术',
  '网络工程',
  '物联网工程',
  '数据科学与大数据技术',
  '人工智能',
  '电子信息工程',
  '自动化',
  '电子商务',
  '数字媒体技术',
]

const COMMON_DIRECTIONS = {
  software: [
    {
      name: '后端开发',
      fit: '适合愿意长期写代码、喜欢拆业务流程和数据库逻辑的同学。',
      abilities: ['Java / Python 基础', '数据库和接口', 'Git 与部署', '把功能讲清楚'],
      projects: ['校园预约系统', '库存管理系统', 'AI 简历优化助手'],
      certificates: ['软考初级/中级', '英语四级/六级', '云计算认证'],
      competitions: ['蓝桥杯', '中国软件杯', '中国大学生计算机设计大赛'],
      jobs: ['Java 后端实习生', '软件开发工程师', '系统开发助理'],
    },
    {
      name: '前端 / 全栈开发',
      fit: '适合喜欢界面、交互和快速做出可展示作品的同学。',
      abilities: ['HTML/CSS/JavaScript', 'React 或 Vue', '接口联调', '移动端适配'],
      projects: ['个人作品集网站', '校园活动报名页', '数据看板'],
      certificates: ['英语四级/六级', '软考初级', '计算机二级（非必需）'],
      competitions: ['计算机设计大赛', '服务外包创新创业大赛', 'UI/UX 设计挑战'],
      jobs: ['前端实习生', 'Web 开发助理', '低代码/全栈助理'],
    },
    {
      name: '测试 / 运维 / 云服务',
      fit: '适合细心、愿意排查问题、对系统稳定性有兴趣的同学。',
      abilities: ['测试用例', 'Linux 基础', '网络和云服务', '问题复盘'],
      projects: ['接口测试报告', '云部署记录', '自动化巡检脚本'],
      certificates: ['华为 HCIA/HCIP', '云计算认证', '软考网络方向'],
      competitions: ['华为 ICT', '蓝桥杯', '网络安全入门赛'],
      jobs: ['测试实习生', '运维助理', '云服务技术支持'],
    },
  ],
  data: [
    {
      name: '数据分析',
      fit: '适合对数字敏感、愿意从业务问题里找规律的同学。',
      abilities: ['Excel / SQL', 'Python 数据处理', '指标拆解', '图表表达'],
      projects: ['电商订单分析报告', '校园问卷分析', '销售看板'],
      certificates: ['英语四级/六级', '数据分析相关证书', '计算机二级'],
      competitions: ['数学建模', '阿里天池', 'Kaggle'],
      jobs: ['数据分析实习生', '运营分析助理', '商业分析助理'],
    },
    {
      name: 'AI 应用 / 机器学习入门',
      fit: '适合愿意学数学和 Python，并能把模型结果解释给别人听的同学。',
      abilities: ['Python', '数据清洗', '基础机器学习', '模型结果解释'],
      projects: ['评论情感分析', '简历匹配小工具', '预测模型报告'],
      certificates: ['英语四级/六级', '云计算认证', '数据分析证书'],
      competitions: ['Kaggle', '阿里天池', '数学建模'],
      jobs: ['AI 应用实习生', '算法助理', '数据挖掘助理'],
    },
  ],
  network: [
    {
      name: '网络工程 / ICT',
      fit: '适合喜欢网络、设备、拓扑和现场排障的同学。',
      abilities: ['计算机网络', '路由交换', 'Linux', '故障定位'],
      projects: ['校园网络拓扑说明', '云服务器部署记录', '网络监控看板'],
      certificates: ['华为 HCIA/HCIP', '软考网络方向', '英语四级'],
      competitions: ['华为 ICT', '蓝桥杯', '网络安全竞赛'],
      jobs: ['网络工程师助理', 'ICT 技术支持', '运维实习生'],
    },
  ],
  iot: [
    {
      name: '物联网 / 嵌入式应用',
      fit: '适合愿意同时接触硬件、传感器和软件展示的同学。',
      abilities: ['单片机基础', '传感器采集', '通信协议', '数据展示'],
      projects: ['智能小车', '环境监测看板', '设备数据采集系统'],
      certificates: ['华为 HCIA', '电工/安全培训类证书', '英语四级'],
      competitions: ['电子设计竞赛', 'RoboMaster', '物联网应用赛'],
      jobs: ['嵌入式助理', '物联网开发实习生', '硬件测试助理'],
    },
  ],
  electronics: [
    {
      name: '电子硬件 / 嵌入式',
      fit: '适合动手能力强、愿意调电路和写说明文档的同学。',
      abilities: ['电路基础', 'PCB / 单片机', '传感器调试', '实验记录'],
      projects: ['传感器采集 demo', '智能小车', '硬件调试记录册'],
      certificates: ['电工证（按岗位判断）', '华为 ICT', '英语四级'],
      competitions: ['大学生电子设计竞赛', 'RoboMaster', '工程训练竞赛'],
      jobs: ['硬件测试助理', '嵌入式实习生', '电子工程助理'],
    },
  ],
  automation: [
    {
      name: '自动化控制 / 工业数字化',
      fit: '适合喜欢系统控制、现场设备和工程流程的同学。',
      abilities: ['控制原理', 'PLC / 单片机', '传感器', '工程文档'],
      projects: ['自动化控制 demo', '设备维护记录系统', '生产数据看板'],
      certificates: ['电工证（按岗位判断）', 'CAD / SolidWorks', '安全培训证书'],
      competitions: ['电子设计竞赛', '工程训练竞赛', '机械创新设计大赛'],
      jobs: ['自动化工程助理', '设备工程实习生', '工业软件助理'],
    },
  ],
  ecommerce: [
    {
      name: '电商运营 / 新媒体运营',
      fit: '适合喜欢内容、平台规则、数据复盘和用户增长的同学。',
      abilities: ['选题策划', '内容制作', '店铺/账号数据', '活动复盘'],
      projects: ['小红书选题分析表', '校园店铺数据看板', '内容日历'],
      certificates: ['英语四级', 'Office / WPS', '新媒体证书（作品优先）'],
      competitions: ['互联网+创新创业类', '挑战杯', '广告艺术大赛'],
      jobs: ['电商运营助理', '新媒体运营实习生', '内容策划助理'],
    },
    {
      name: '产品 / 数据运营',
      fit: '适合喜欢分析用户行为、整理需求和推进小项目的同学。',
      abilities: ['需求分析', '数据看板', '用户调研', '原型表达'],
      projects: ['用户反馈分析', '活动转化漏斗', '校园服务小程序原型'],
      certificates: ['英语四级/六级', '数据分析证书', 'Office / WPS'],
      competitions: ['服务外包创新创业大赛', '互联网+', '数学建模'],
      jobs: ['产品助理', '运营分析助理', '商业策划助理'],
    },
  ],
  media: [
    {
      name: '数字媒体 / UI 设计',
      fit: '适合有审美表达、愿意做作品集和展示页面的同学。',
      abilities: ['Figma / PS', '版式和色彩', '交互流程', '作品集叙事'],
      projects: ['个人作品集网站', '校园活动视觉方案', 'App 页面改版'],
      certificates: ['Adobe 相关认证（辅助）', '英语四级', '普通话（看方向）'],
      competitions: ['广告艺术大赛', 'UI/UX 设计挑战', '米兰设计周'],
      jobs: ['UI 设计助理', '视觉设计实习生', '新媒体设计助理'],
    },
    {
      name: '内容创作 / AIGC 应用',
      fit: '适合喜欢写脚本、做视频、用 AI 工具提升内容效率的同学。',
      abilities: ['脚本结构', '短视频剪辑', 'AI 绘图/文案', '数据复盘'],
      projects: ['AI 海报生成流程', '短视频栏目策划', '个人品牌内容日历'],
      certificates: ['新媒体证书（谨慎）', '普通话', '英语四级'],
      competitions: ['短视频创作比赛', '广告艺术大赛', '新媒体内容创作赛'],
      jobs: ['内容运营实习生', 'AIGC 设计助理', '短视频策划助理'],
    },
  ],
}

export function inferMajorCareerGroup(input) {
  const value = String(input || '').toLowerCase()
  if (/数据|大数据|统计|分析/.test(value)) return 'data'
  if (/网络/.test(value)) return 'network'
  if (/物联网/.test(value)) return 'iot'
  if (/电子信息|电子工程|通信/.test(value)) return 'electronics'
  if (/自动化|控制/.test(value)) return 'automation'
  if (/电子商务|电商|市场|营销/.test(value)) return 'ecommerce'
  if (/数字媒体|视觉|设计|新媒体/.test(value)) return 'media'
  if (/人工智能|ai|机器学习/.test(value)) return 'data'
  if (/软件|计算机|前端|后端|编程|程序/.test(value)) return 'software'
  return 'software'
}

export function getMajorCareerRecommendation(input) {
  const major = String(input || '').trim() || '软件工程'
  const group = inferMajorCareerGroup(major)
  const directions = COMMON_DIRECTIONS[group] || COMMON_DIRECTIONS.software
  return {
    major,
    group,
    directions,
    summary: `${major} 可以先从 2-3 个方向里选一个主线：岗位方向、作品项目、竞赛/证书要互相服务，不要分散准备。`,
  }
}
